import { render, staticRenderFns } from "./ToFollow.vue?vue&type=template&id=4d8137f3&scoped=true&"
import script from "./ToFollow.vue?vue&type=script&lang=js&"
export * from "./ToFollow.vue?vue&type=script&lang=js&"
import style0 from "./ToFollow.vue?vue&type=style&index=0&id=4d8137f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8137f3",
  null
  
)

export default component.exports